/**
 * Given a template, and an object of key-value pairs, replace all occurrences of
 * each key with the associated value in the string
 * 
 * @param {string} template 
 * @param {object} pairs 
 * @returns Formatted string
 */
export function stringFormatter(template, pairs) {
  if (!template || !pairs) {
    return "";
  }

  let formattedString = template;
  Object.keys(pairs).forEach((key) => {
    const value = pairs[key];
    formattedString = formattedString.replaceAll(`{${key}}`, value);
  });
  return formattedString;
}